export default "__VITE_ASSET__64873acd__"